import script from "./EntityIconSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityIconSelector.vue?vue&type=script&setup=true&lang=js"

import "./EntityIconSelector.vue?vue&type=style&index=0&id=68867b26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68867b26"]])

export default __exports__